// Named so the absorbed-fee behaviour is greppable and cannot be "tidied away":
// a fee line passes no showZeroValue, so a venue that absorbs the fee (value 0)
// renders no row at all. Only Subtotal and Total opt into showing a zero.
// Type predicate so callers still narrow `value` to number, as the inline guard did.
export const shouldRenderPaymentItem = (value: number | undefined, showZeroValue?: boolean): value is number =>
    typeof value === "number" && !(value === 0 && !showZeroValue);
